import { Col, Row, Text, VerticalSeparator } from "../../../style/base.style";

interface VerticalSepWithTitleProps {
    title?: string;
    color?: string;
}

export const VerticalSepWithTitle = ({title,color}:VerticalSepWithTitleProps) => {
    return (
        <Row $width="100%" $alignItems="center" $wrap="nowrap">
          {
            title && 
            <><Col $width="100%">
            <VerticalSeparator $color={color}/>
        </Col>
        <Col $width="100%" $justifyContent="center" $alignItems="center">
            <Text $color={color} $margin="0px 0px">{title}</Text>
        </Col>
        <Col $width="100%">
            <VerticalSeparator $color={color}/>
        </Col></>
          }
          {
            !title &&
            <><Col $width="100%">
            <VerticalSeparator $color={color}/>
        </Col></>
          }
        </Row>
    )

}